import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20abstract%20geometric%20patterns%20with%20warm%20red%20and%20gold%20gradients%20on%20a%20dark%20elegant%20background%2C%20smooth%20flowing%20curves%20and%20overlapping%20circles%2C%20luxurious%20and%20professional%20atmosphere%2C%20clean%20minimalist%20style%2C%20subtle%20texture%20and%20depth%2C%20digital%20data%20visualization%20aesthetic%2C%20no%20text%20or%20letters%2C%20high%20contrast%20dark%20background&width=1600&height=600&seq=hero-bg-2024&orientation=landscape"
        alt="彩客网新版官网背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary-500/20 backdrop-blur-sm border border-primary-300/30 rounded-full mb-6">
          <i className="ri-sparkling-2-line text-accent-400 text-sm"></i>
          <span className="text-xs md:text-sm text-background-50/90 font-medium">
            彩客网新版官网全面升级上线
          </span>
        </div>
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 max-w-3xl leading-tight">
          全新升级体验更流畅
        </h1>
        <p className="mt-4 md:mt-6 text-sm md:text-lg text-background-50/70 max-w-2xl leading-relaxed">
          极速彩票数据查询 · 开奖结果实时推送 · 智能分析预测
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 mt-8 md:mt-10">
          <Link
            to="/category/shuangseqiu"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-lg text-sm md:text-base font-medium hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
          >
            立即查询开奖数据
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 rounded-lg text-sm md:text-base font-medium hover:bg-background-50/25 transition-all cursor-pointer whitespace-nowrap"
          >
            了解彩客网
          </Link>
        </div>
        <div className="flex items-center gap-6 mt-10 md:mt-14">
          <div className="text-center">
            <p className="text-xl md:text-2xl font-bold text-background-50">500万+</p>
            <p className="text-xs text-background-50/50 mt-1">注册用户</p>
          </div>
          <div className="w-px h-8 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-xl md:text-2xl font-bold text-background-50">10年</p>
            <p className="text-xs text-background-50/50 mt-1">行业深耕</p>
          </div>
          <div className="w-px h-8 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-xl md:text-2xl font-bold text-background-50">99.9%</p>
            <p className="text-xs text-background-50/50 mt-1">数据准确率</p>
          </div>
        </div>
      </div>
    </section>
  );
}